import _asyncToGenerator from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import { axiosInstance } from 'boot/axios';
import { echoInstance } from 'boot/websocket';
import Dialog from 'quasar/src/plugins/Dialog.js';import Notify from 'quasar/src/plugins/Notify.js';;
import Vue from 'vue';
var apiError = false;
export function api(_x, _x2) {
  return _api.apply(this, arguments);
}

/**
 * This function will display API error response in Notify style.
 *
 * @param e
 */
function _api() {
  _api = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, options) {
    var commit, dispatch, method, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          commit = _ref.commit, dispatch = _ref.dispatch;
          // Define auth instance service...
          // const authService = getInstance()

          // Start Wait package...
          Vue.nextTick(function () {
            startApiWaits(dispatch, options);
          });
          _context.t0 = options.method;
          _context.next = _context.t0 === 'post' ? 5 : _context.t0 === 'put' ? 5 : _context.t0 === 'patch' ? 5 : _context.t0 === 'delete' ? 10 : _context.t0 === 'get' ? 13 : 13;
          break;
        case 5:
          data = new FormData();
          if (options.data) {
            Object.keys(options.data).forEach(function (key) {
              if (options.avoidArrayJoin && Array.isArray(options.data[key])) {
                var arr = options.data[key];
                arr.forEach(function (item) {
                  data.append("".concat(key, "[]"), item);
                });
              } else {
                data.append(key, options.data[key]);
              }
            });
          }
          data.append('_method', options.method);
          method = 'post';
          return _context.abrupt("break", 15);
        case 10:
          data = {};
          method = 'delete';
          return _context.abrupt("break", 15);
        case 13:
          data = {};
          method = 'get';
        case 15:
          // Commit before request
          if (options.commitBefore) {
            commit(options.commitBefore);
          }

          // Add X-socket-ID to the request headers
          axiosInstance.interceptors.request.use(function (config) {
            config.headers['X-Socket-ID'] = echoInstance.socketId();
            return config;
          });

          // Make API request
          return _context.abrupt("return", axiosInstance({
            method: method,
            url: "".concat(options.excludeApiPrefix ? '' : '/api/').concat(options.url),
            data: data,
            params: options.params || {},
            cancelToken: options.cancelToken
          }).then(function (response) {
            // Commit mutation after request
            if (options.commitAfter) {
              commit(options.commitAfter, response.data);
            }
            endApiWaits(dispatch, options);

            // Callback
            if (typeof options.callback === 'function') {
              options.callback();
            }
            return Promise.resolve(response);
          }).catch(function (error) {
            endApiWaits(dispatch, options);
            if (error.message === 'canceled') return Promise.reject(error);
            var e = error.response;

            // No API server
            if (!e && !apiError) {
              Dialog.create({
                title: 'API Error',
                message: 'An error occurred on API request. \n' + error,
                class: 'bg-negative',
                color: 'white',
                persistent: true,
                ok: false
              });
              apiError = true;
              throw new Error('An error occurred on API request. ' + error);
            }
            // 401 Not authorized
            switch (e.status) {
              case 401:
                // Unauthenticated
                displayError('Unauthenticated');
                break;
              case 400:
                // 400 Wrong credentials
                displayError('Email or password is incorrect.');
                break;
              case 403:
                // 403 Unauthorized
                displayError('Unauthorized.');
                break;
              case 422: // 422 Validation
              case 404:
              case 500:
              default:
                displayApiError(error);
                break;
            }
            return Promise.reject(error);
          }));
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _api.apply(this, arguments);
}
function displayApiError(e) {
  var error = e.response;
  var message = error.data && error.data.message.length > 0 ? "<strong>".concat(error.data.message, "</strong>") : "<strong><em>Unknown</em></strong>";

  // Check if we have errors list (by validation mainly)
  var listErrorItems = '';
  if (error.data && error.data.errors && Object.keys(error.data.errors).length > 0) {
    Object.keys(error.data.errors).forEach(function (key) {
      listErrorItems += "<li>".concat(error.data.errors[key], "</li>");
    });
    message += "<ul>".concat(listErrorItems, "</ul>");
  }
  displayError(message);
}

/**
 * Display an error message as Notification
 *
 * @param message
 */
function displayError(message) {
  Notify.create({
    color: 'negative',
    position: 'top-right',
    message: message,
    icon: 'report_problem',
    html: true,
    timeout: 10000,
    actions: [{
      icon: 'close',
      handler: Function,
      color: 'white'
    }]
  });
}

/**
 * Start API Waits
 *
 * @param dispatch
 * @param options
 */
function startApiWaits(dispatch, options) {
  dispatch('wait/start', 'api', {
    root: true
  });
  dispatch('wait/start', options.url, {
    root: true
  });
  if (options.wait) {
    dispatch('wait/start', options.wait, {
      root: true
    });
  }
}

/**
 * End API Waits
 *
 * @param dispatch
 * @param options
 */
function endApiWaits(dispatch, options) {
  dispatch('wait/end', 'api', {
    root: true
  });
  dispatch('wait/end', options.url, {
    root: true
  });
  if (options.wait) {
    dispatch('wait/end', options.wait, {
      root: true
    });
  }
}